import { ILanguage, RootState } from '@checkout/state';
import * as React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { Persistor } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { LangSwitcher } from './../components/container';
import ConnectedIntlProvider from './../wrappers/ConnectedIntlProvider';
import ErrorBoundary from './../wrappers/ErrorBoundary';

interface IOwnProps {
  store: Store<RootState>;
  persistor: Persistor;
  languages: ILanguage[];
  intlData?: IntlProvider.Props;
}

const FailureApp: React.SFC<IOwnProps> = ({ store, persistor, languages, intlData }) => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedIntlProvider {...intlData} >
        <ErrorBoundary>
          <LangSwitcher languages={languages} />
        </ErrorBoundary>
      </ConnectedIntlProvider>
    </PersistGate>
  </Provider>
);

export default FailureApp;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/apps/LangSwitcherApp.tsx